<template>
  <div class="content">
    <el-form ref="schemeForm" :model="schemeForm" :rules="schemeRules"  label-width="100px">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>方案信息</span>
        </div>
        <el-form-item label="方案名称" prop="name" style="width:60%">
            <el-input v-model="schemeForm.name" placeholder="方案名称"></el-input>
        </el-form-item>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span style="color: #ff4949;margin-right: 4px;">*</span><span>套餐信息</span>
        </div>
        <!-- <el-form-item label="" style="margin-top: 10px;"> -->
          <el-table :data="schemeForm.services" row-key="id"
            :default-expand-all="true" max-height="400" border
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <!-- <el-table-column type="index" align="center" width="60px"></el-table-column> -->
            <el-table-column prop="productName" label="套餐名称" align="center"  :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="showProductName" label="公众号展示名称" align="center" width="200">
              <template #default={row}>
                <el-input v-if="!!row.productName" v-model="row.showProductName"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="operationName" label="运营商" align="center"  ></el-table-column>
            <template v-if="schemeForm.self == '1'">
              <el-table-column v-if="!adminShow" prop="basePrice" label="成本价（元）" align="center"  ></el-table-column>
              <el-table-column  prop="ledgerPrice" label="底价（元）" align="center" >
                <template #default={row}>
                  <el-input style="width: 80px;" v-model="row.ledgerPrice"
                    :class="{ 'is-error': ledgerPriceError(row)}"
                    oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"></el-input>
                </template>
              </el-table-column>
            </template>
            <template v-if="schemeForm.self == '0'">
              <el-table-column prop="ledgerPrice" label="成本价（元）" align="center"  ></el-table-column>
            </template>
            <el-table-column prop="salePrice" label="售价（元）" align="center" >
              <template #default={row}>
                <el-input style="width: 80px;" v-model="row.salePrice"
                  :class="{ 'is-error': salePriceError(row)}"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"></el-input>
              </template>
            </el-table-column>
          </el-table>
        <!-- </el-form-item> -->
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>
              <el-tooltip content="此方案加入另外批次卡片，多个批次共享方案" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
              新加卡片
            </span>
        </div>
        <el-form-item label="代理商" prop="userId" style="width:60%">
            <el-select v-model="schemeForm.userId" placeholder="请选择代理商" clearable filterable  style="width:100%">
              <el-option v-for="item in agentList" :key="item.userId" :label="'['+`${item.username}`+']' + `${item.company}`" :value="item.userId"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="ICCID列表" prop="iccids" >
          <el-input
            v-model="schemeForm.iccids"
            type="textarea"
            :placeholder="'以回车键分割ICCID\n'"
            rows="6"
            style="width:420px;font-size:14px"
          ></el-input>
        </el-form-item>
        <el-form-item label="ICCID范围" prop="startIccid" >
          <el-input
            v-model="schemeForm.startIccid"
            style="width: 200px;margin-right: 10px;"
            placeholder="包含开始值"
          ></el-input>
          <span>-</span>
          <el-input
            v-model="schemeForm.endIccid"
            style="width: 200px;margin-left: 10px;"
            placeholder="包含终止值"
          ></el-input>
        </el-form-item>
        
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>
              卡片列表
            </span>
        </div>
        <el-table :data="tableData" v-loading="loading" border>
            <el-table-column type="index" label="编号" align="center" width="60"></el-table-column>
            <el-table-column prop="companyName" label="代理商" align="center" width="300"></el-table-column>
            <el-table-column prop="iccid" label="ICCID" align="center"></el-table-column>
            <el-table-column prop="msisdn" label="MSISDN" align="center"></el-table-column>
            <el-table-column prop="createTime" label="入库时间" align="center"></el-table-column>
            <el-table-column prop="updateTime" label="出库时间" align="center"></el-table-column>
            <el-table-column prop="status" label="状态" align="center">
              <template slot-scope="{row}">
                 <el-tag v-if="row.status == '1'" >已分配</el-tag>
                 <el-tag v-if="row.status == '0'" type="warning">未分配</el-tag>
              </template>
            </el-table-column>
        </el-table>
        <div class="block" style="margin-top: 30px;">
            <pagination v-show="total>0" :total="total" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" :page.sync="page"
            :limit.sync="pageSize" @pagination="initData" />
        </div>
      </el-card>
      
    </el-form>
    <div class="foot">
		<el-button type="primary" @click="submitScheme">修改方案</el-button>
	</div>
  </div>
</template>
<script>
import {agentListsData, baseSchemeProductSubList , baseSchemeCard , schemeDetail} from "@/api/api.js"; 
import { editBaseScheme } from "@/api/api.js";
export default {
  name:'editScheme',
  data() {
    return {
      schemeId:undefined,
      schemeForm:{
        userId:0,
        self:0,
        username:undefined,
        companyName:undefined,
        services:[]
      },
      agentList:[],
      schemeRules:{
        name: [
          { required: true, message: "请输入方案名称", trigger: "blur" },
        ],
      },
      loading:false,
      tableData:[],
      total:0,
      page:1,
      pageSize:10,
    };
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    }
  },
  methods: {
    initAgentList(){
      let params = {
        model: {
            commissionModel:1,
            levels:["1"]
        },
        page: 1,
        pageSize: 5000,
      };
      agentListsData(params).then(res => {
        this.agentList = res.data.data.records;
      });
    },
    initData(){
      this.loading = true;
      let params = {
        model:{
		      schemeId:this.schemeId,
		    },
        page: this.page,
        pageSize: this.pageSize,
      };
      baseSchemeCard(params).then(res => {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.loading = false;
      });
    },
    initSchemeDetail(){
      schemeDetail({schemeId:this.schemeId}).then(res=>{
          this.schemeForm = res.data.data
      })

    },
    initSubSchemeProduct(){
        baseSchemeProductSubList({id:this.schemeId}).then(res=>{
            this.schemeForm.services = res.data.data
        })
    },
    submitScheme(){
      this.$refs.schemeForm.validate(valid=>{
        if (valid) {
          let data = this.getProdcutData()
          if(data.length == 0){
            this.$modal.msgError("请选择套餐");
            return 
          }
          let arrShow = true;
          let msg = "底价或者售价输入不正确";
          data.forEach(item=>{
            if(!item.ledgerPrice){
              arrShow = false
              msg="底价不能为空";
              return 
            }
            if(item.ledgerPrice < item.basePrice){
              arrShow = false
              msg="底价必须大于成本价";
              return 
            }
            if(!item.salePrice){
              arrShow = false
              msg="售价不能为空";
              return 
            }
            if(item.salePrice < item.ledgerPrice){
              arrShow = false
              msg="售价必须大于底价";
              return 
            }
          })
          if(!arrShow){
            this.$modal.msgError(msg);
            return 
          }else{
            //保存方案
            let params = {
              ...this.schemeForm,
              schemeId:this.schemeId,
              iccids:!!this.schemeForm.iccids ? this.schemeForm.iccids.split("\n") : []
            };
            editBaseScheme(params).then(res=>{
              this.$message({type: 'success',message: '修改方案成功'});
              this.$router.push('/scheme/list')
            })
          }
        }
      })
    },
    getProdcutData(){
      let data = this.schemeForm.services;
      if(!!data && data.length>0){
        let prodcuts = []
        data.forEach(item=>{
          prodcuts.push(item)
          let children = item.children;
          if(children && children.length>0){
              children.forEach(ch=>{
                prodcuts.push(ch);
              })
          }
        })
        return prodcuts;
      }
      return [];  
    },
    salePriceError(row){
      return !row.salePrice || row.salePrice < row.ledgerPrice
    },
    //底价
    ledgerPriceError(row){
      return !row.ledgerPrice || row.ledgerPrice < row.basePrice
    }
    
  },
  mounted() {
  },
  created() {
    this.schemeId = this.$route.params && this.$route.params.id
    this.initAgentList()
    this.initData()
    this.initSchemeDetail()
  }
};
</script>
<style scoped lang="less">
  .box-card {
    margin-bottom: 26px;
  }
  .foot {
		width: calc(100% - 210px);
		position: fixed;
		right: 0;
		bottom: 0;
		height: 60px;
		line-height: 60px;
		background-color: white;
		text-align: center;
		padding: 0 20px;
    z-index: 99999;
	}
  ::v-deep .is-error .el-input__inner {
    border-color: red;
    background-color: #ffeef0;
  }
</style>
